<template>
  <div
    class="checkbox-input checkbox-input--default"
    :class="{
      'checkbox-input--has-label': labelStyle !== 'hidden'
    }"
  >
    <template v-if="labelStyle !== 'hidden'">
      <p
        v-if="labelStyle === 'small'"
        class="title title--6 half-spacing"
      >
        {{ label }}
      </p>

      <p
        v-else
        class="title title--6 half-spacing"
      >
        {{ label }}
        <span
          v-if="showAsOptional && !validations.required"
          class="gray regular smaller"
        >
          (Optional)
        </span>
      </p>
    </template>

    <div class="checkbox-input__options">
      <div
        v-for="(option, index) in options"
        :key="option.value"
        class="checkbox-input__option"
      >
        <input
          :id="name + index"
          v-model="selectedValues[index]"
          :disabled="option.disabled"
          :name="name"
          class="checkbox-input__input"
          type="checkbox"
        >
        <label
          :for="name + index"
          class="checkbox-input__label"
        >
          <span class="checkbox-input__label-text">
            {{ option.display }}

            <span
              v-if="option.subDisplay"
              class="checkbox-input__label-sub-text"
            >
              {{ option.subDisplay }}
            </span>
          </span>
        </label>
      </div>
    </div>

    <input-error :error="errorMessage ? 'An option must be selected.' : null" />
  </div>
</template>



<script>
  import { watch } from 'vue';
  import { useField } from 'vee-validate';

  export default {
    name: 'ChecklistInput',

    props: {
      label: {
        type: String,
        required: true
      },

      labelStyle: {
        type: String,
        default: ''
      },

      name: {
        type: String,
        required: true
      },

      options: {
        type: Array,
        required: true
      },

      showAsOptional: {
        type: Boolean,
        default: false
      },

      validations: {
        type: Object,
        default: () => ({})
      },

      modelValue: {
        type: Array,
        default: () => ([])
      }
    },

    // VeeValidate 4 requires the Composition API to register a field with the parent form context.
    // setup() is used exclusively for that purpose — all other component logic
    // remains in the Options API below.
    // Exposes: errorMessage (reactive validation error string, undefined when valid)
    // Note: handleChange is used internally by the watch() below and is not exposed.
    setup(props) {
      const { errorMessage, handleChange } = useField(() => props.name, () => props.validations, {
        initialValue: props.modelValue
      });

      watch(() => props.modelValue, handleChange);

      return { errorMessage };
    },

    data: () => ({
      selectedValues: {}
    }),

    watch: {
      selectedValues: {
        handler: 'selectedValuesChangeHandler',
        deep: true,
        immediate: true
      }
    },

    methods: {
      selectedValuesChangeHandler(values) {
        const result = this.options.reduce((array, option, index) => {
          if (values[index]) array.push(option.value);
          return array;
        }, []);

        this.$emit('update:modelValue', result);
      }
    }
  };
</script>
